import * as yup from "yup";

export const errors = {
  required: "This field is required.",
  invalidEmail: "Invalid Email",
  invalidPhone: "Invalid entry. Use only numbers, spaces, and dashes.",
  invalidPassword:
    "Must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character from the following: @$!%*#?&",
  noFoundGenes: (invalidGenes: string[]) =>
    `The provided target(s) are not valid HGNC symbols: ${invalidGenes.join()}. Please correct and provide a new target list.`,
};

export interface IForm {}

export interface IFormField<T> {
  name: Extract<keyof T, string>;
  label?: string; // A default value is to convert name to Sentence Case.
  type?: "text" | "email" | "password" | "checkbox" | "password" | "tel"; // A default value is text.
  required?: boolean; // A default value is true.
}

export const passwordValidation = yup
  .string()
  .required(errors.required)
  .matches(
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{9,}$/,
    errors.invalidPassword
  );

export interface ICustomPanelForm extends IForm {
  panelName: string;
  panels: any;
  msi?: boolean;
  snpId?: boolean;
  status?: "draft" | "in_progress" | "quote_requested";
}
